import apiFetch from '../apiFetch'

export default function (token, conditionDocumentalCampaignDto) {
  return apiFetch({ endPoint: 'ConditionDocumentalCampaign/InsertCondition', method: 'POST', body: conditionDocumentalCampaignDto, token: token })
}
